import { lazy, Suspense } from 'react'
import { Navigate, Route, Routes } from 'react-router'
import { RequireAdmin, RequireAuth } from './auth/RequireAuth'
import { CapaTooltips } from './components/chrome/CapaTooltips'
import { NavegacionGlobal } from './components/chrome/NavegacionGlobal'

// Mapa de rutas (stack.md §Rutas) — lazy por página para no cargar módulos que no se usan.
const Bienvenida = lazy(() => import('./pages/Bienvenida'))
const Dashboard = lazy(() => import('./pages/Dashboard'))
const Proyecto = lazy(() => import('./pages/Proyecto'))
const MisTareas = lazy(() => import('./pages/MisTareas'))
const Panorama = lazy(() => import('./pages/Panorama'))
const Chat = lazy(() => import('./pages/Chat'))
const Celulas = lazy(() => import('./pages/Celulas'))
const Directorio = lazy(() => import('./pages/Directorio'))
const Admin = lazy(() => import('./pages/Admin'))
const Papelera = lazy(() => import('./pages/Papelera'))
// Ligas viejas de Basecamp → su equivalente en camp (/bc?u=…).
const LigaBasecamp = lazy(() => import('./pages/LigaBasecamp'))
// Ola 2 del agente local: el perfil (IA en esta Mac, Mis máquinas) y la pantalla que
// confirma el enlace de una Mac. /enlazar va detrás de la sesión a propósito: el
// candado del enlace ES la sesión de Google de quien confirma.
const Ayuda = lazy(() => import('./pages/Ayuda'))
const Perfil = lazy(() => import('./pages/Perfil'))
const Enlazar = lazy(() => import('./pages/Enlazar'))

export function App() {
  return (
    <>
    {/* Fuera del Suspense: el tooltip, el scroll al regresar y los atajos de
        atrás valen en TODAS las pantallas, también mientras baja una página. */}
    <CapaTooltips />
    <NavegacionGlobal />
    <Suspense fallback={<div className="app-content" aria-busy="true"><div className="skel skel-card" /></div>}>
      <Routes>
        <Route path="/bienvenida" element={<Bienvenida />} />
        <Route element={<RequireAuth />}>
          <Route path="/" element={<Dashboard />} />
          <Route path="/p/:pid" element={<Proyecto />} />
          <Route path="/p/:pid/:tab" element={<Proyecto />} />
          <Route path="/p/:pid/t/:boardId" element={<Proyecto />} />
          <Route path="/mis-tareas" element={<MisTareas />} />
          <Route path="/panorama" element={<Panorama />} />
          <Route path="/chat" element={<Chat />} />
          <Route path="/chat/:chatId" element={<Chat />} />
          <Route path="/celulas" element={<Celulas />} />
          <Route path="/directorio" element={<Directorio />} />
          <Route path="/papelera" element={<Papelera />} />
          <Route path="/bc" element={<LigaBasecamp />} />
          <Route path="/ayuda" element={<Ayuda />} />
          <Route path="/perfil" element={<Perfil />} />
          <Route path="/enlazar" element={<Enlazar />} />
          <Route element={<RequireAdmin />}>
            <Route path="/admin" element={<Admin />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </Suspense>
    </>
  )
}
